import React from "react";
import Div from "app/components/Div";

export const LineSeparator = () => (
  <Div px={2} my={2}>
    <Div height="1px" bg="monochrome.1" width="100%" />
  </Div>
);
